import { lazy } from 'react';

import type { RouteConfig } from '../../types';

// Lazy load layouts
const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const JobsReportLayout = lazy(() => import('@/pages/reports/jobs/layout'));
const TtiReportLayout = lazy(() => import('@/pages/reports/tti-report/layout'));

// Lazy load report pages
const ClientCompaniesRateCardsPage = lazy(() => import('@/pages/reports/client-companies-rate-cards'));
const JeopardyReportPage = lazy(() => import('@/pages/reports/jeopardy-report'));
const JobsAgGridPage = lazy(() => import('@/pages/reports/jobs'));
const ProjectsDashboardPage = lazy(() => import('@/pages/reports/projects-dashboard'));
const ProjectsExecutionForecastPage = lazy(() => import('@/pages/reports/projects-execution-forecast'));
const ProjectsRevenueForecastPage = lazy(() => import('@/pages/reports/projects-revenue-forecast'));
const RevenueForecastPage = lazy(() => import('@/pages/reports/revenue-forecast'));
const TtiReportPage = lazy(() => import('@/pages/reports/tti-report'));
const VendorReportPage = lazy(() => import('@/pages/reports/vendor-report'));
const WorkableForecastReportPage = lazy(() => import('@/pages/reports/workable-forecast-report'));
const WorkforceForecastPage = lazy(() => import('@/pages/reports/workforce-forecast'));
const AgingCXReportPage = lazy(() => import('@/pages/reports/aging-cx-report'));

/**
 * Report routes
 * Handles various reporting features
 */
export const reportRoutes: RouteConfig = {
  path: '/reports',
  layout: DashboardLayout,
  children: [
    {
      path: '/client-companies-rate-cards',
      element: ClientCompaniesRateCardsPage,
    },
    {
      path: '/jeopardy-report',
      element: JeopardyReportPage,
    },
    {
      path: '/jobs',
      layout: JobsReportLayout,
      element: JobsAgGridPage,
    },
    {
      path: '/projects-dashboard',
      element: ProjectsDashboardPage,
    },
    {
      path: '/projects-execution-forecast',
      element: ProjectsExecutionForecastPage,
    },
    {
      path: '/projects-revenue-forecast',
      element: ProjectsRevenueForecastPage,
    },
    {
      path: '/revenue-forecast',
      element: RevenueForecastPage,
    },
    {
      path: '/tti-report',
      layout: TtiReportLayout,
      element: TtiReportPage,
    },
    {
      path: '/vendor-report',
      element: VendorReportPage,
    },
    {
      path: '/workable-forecast-report',
      element: WorkableForecastReportPage,
    },
    {
      path: '/workforce-forecast',
      element: WorkforceForecastPage,
    },
    {
      path: '/aging-cx',
      element: AgingCXReportPage,
    },
  ],
};
